export default "__VITE_ASSET__6aa37bc2__"